import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  overviewContent,
  kubernetesContent,
  dependenciesContent,
  featuresContent,
  datadogContent,
  codeInsightsContent,
  systemDiagramContent,
  redocContent,
  badgesContextMenuItem,
  createPreviewContextMenuItem,
} from './contents';

export const entityPageModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    overviewContent,
    kubernetesContent,
    dependenciesContent,
    featuresContent,
    datadogContent,
    codeInsightsContent,
    systemDiagramContent,
    redocContent,
    badgesContextMenuItem,
    createPreviewContextMenuItem,
  ],
});
